/**
 * List of domains that are considered part of the EU region.
 * @type {string[]}
 */
const EU_REGION_DOMAINS = [
  'insights-de.dev.panel-insights.numerator.cloud',
  'verifiedvoices-de.dev.panel-insights.numerator.cloud',
  'insights-de.stg.panel-insights.numerator.cloud',
  'verifiedvoices-de.stg.panel-insights.numerator.cloud',
  'de.insights.numerator.com',
  'de.verifiedvoices.numerator.com',
];

/**
 * Checks if the current URL belongs to a deployed EU domain.
 * @returns {boolean} `true` if the current site is an EU domain, otherwise `false`
 */
export const isEUDomain = () => {
  let hostname = window.location.hostname;

  // Remove 'www.' if present
  hostname = hostname.replace(/^www\./, '');

  return EU_REGION_DOMAINS.includes(hostname);
};

export const isLocalSurveyDomain = import.meta.env.VITE_INSTANT_SURVEY_ISLOCAL === 'true';
